// extracted by mini-css-extract-plugin
module.exports = {"langWrapper":"styles_langWrapper__Jze0i","container":"styles_container__OJb2R"};